import React from 'react'
// TODO move ui
// import { Text } from '@brainstud/schiphol-vtc-ui'
import Intro from '../Intro'
import Help from '../../shared/quizhelp'

const Endtest = props => (
  <Intro
    title="Test Je Kennis!"
    side={
      <div>
        <Text lead style={{ paddingRight: '6rem' }}>{props.quiz.info}</Text>
        <Help.endtest {...props} />
      </div>
    }
    main={
      <div>
        <Text>Na afloop van de eindtoets kun je alle vragen en antwoorden inzien, om te ontdekken wat er (minder) goed ging. We geven dan ook aan welke hoofdstukken je het beste nog even kunt doornemen.</Text>
      </div>
    } />
)

export default Endtest
